import React from 'react';
import LockOutlined from '@mui/icons-material/LockOutlined';
import { Search as SearchIcon, Close as CloseIcon, Person as PersonIcon, KeyboardReturn as EnterIcon } from '@mui/icons-material';
import { useBuscadorGlobal } from '../../hooks/useBuscadorGlobal';

// El atajo funciona con ⌘ en Mac y con Ctrl en Windows y Linux
const ATAJO = /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent) ? '⌘K' : 'Ctrl K';

export default function BuscadorGlobal() {
    const { open, setOpen, query, setQuery, resultados, loading, inputRef, handleSelect } = useBuscadorGlobal();

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                className="hidden md:flex items-center gap-3 px-4 py-2 text-sm font-medium text-slate-400 bg-slate-100 hover:bg-slate-200 hover:text-slate-600 rounded-xl transition-colors w-64 border border-slate-200/50"
            >
                <SearchIcon fontSize="small" />
                <span>Buscar paciente...</span>
                <span className="ml-auto text-[10px] font-bold border border-slate-300 rounded px-1.5 py-0.5">{ATAJO}</span>
            </button>

            {open && (
                <div
                    className="fixed inset-0 z-[100] flex items-start justify-center pt-20 pb-4 px-4 bg-slate-900/60 backdrop-blur-sm"
                    onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}
                    role="presentation"
                >
                    <div className="w-full max-w-2xl bg-white rounded-3xl shadow-2xl overflow-hidden animate-fade-in" role="dialog">
                        <div className="relative flex items-center px-4 py-4 border-b border-slate-100">
                            <SearchIcon className="text-clinica-primary ml-2" />
                            <input
                                ref={inputRef}
                                type="text"
                                className="w-full px-4 text-lg bg-transparent border-none focus:outline-none focus:ring-0 text-slate-900 placeholder-slate-400"
                                placeholder="Buscar por nombre, apellidos o DNI..."
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                            />
                            <button onClick={() => setOpen(false)} className="p-1 text-slate-400 hover:text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors">
                                <CloseIcon fontSize="small" />
                            </button>
                        </div>

                        <div className="max-h-96 overflow-y-auto p-2">
                            {loading && (
                                <div className="flex justify-center py-8">
                                    <div className="w-6 h-6 border-2 border-clinica-primary border-t-transparent rounded-full animate-spin"></div>
                                </div>
                            )}

                            {!loading && query.length > 1 && resultados.length === 0 && (
                                <div className="py-12 text-center">
                                    <p className="text-sm font-bold text-slate-500">No se encontraron pacientes para &quot;{query}&quot;</p>
                                </div>
                            )}

                            {!loading && resultados.map((paciente) => (
                                <button
                                    key={paciente.id || paciente._id}
                                    onClick={() => { if (paciente.accesoHistorial !== false) handleSelect(paciente.id || paciente._id); }}
                                    disabled={paciente.accesoHistorial === false}
                                    className="flex items-center w-full gap-4 px-4 py-3 text-left rounded-2xl hover:bg-slate-50 focus:bg-slate-50 focus:outline-none group transition-colors disabled:cursor-default disabled:hover:bg-transparent"
                                >
                                    <div className="flex items-center justify-center w-10 h-10 font-bold text-slate-600 bg-slate-100 group-hover:bg-clinica-primary group-hover:text-white rounded-full transition-colors shrink-0">
                                        <PersonIcon fontSize="small" />
                                    </div>
                                    <div className="flex-1 overflow-hidden">
                                        <h4 className="text-sm font-bold text-slate-900 group-hover:text-clinica-primary transition-colors truncate">
                                            {paciente.nombre} {paciente.apellidos}
                                        </h4>
                                        <p className="text-xs font-semibold text-slate-500 truncate">{paciente.dni} • {paciente.telefono || 'Sin teléfono'}</p>
                                        {paciente.accesoHistorial === false && <p className="inline-flex items-center gap-1 text-[11px] font-bold text-amber-700"><LockOutlined sx={{ fontSize: 13 }} aria-hidden="true" /> Sin acceso a su historial</p>}
                                    </div>
                                    <EnterIcon fontSize="small" className="text-slate-300 group-hover:text-clinica-primary opacity-0 group-hover:opacity-100 transition-all shrink-0" />
                                </button>
                            ))}

                            {!query && <div className="py-8 text-center text-xs font-bold text-slate-400 uppercase tracking-widest">Escribe para buscar</div>}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}